import React, { useCallback } from 'react';
import { observer } from 'mobx-react-lite';
import { GameResults, popupStore, PopupTypes, roundInfoStore } from '@pascal/pascal-core';
import { globalTranslationKeys } from '../../../enums';
import { RenderResultItem, statusMapper } from '../../../components/common/gameResults';

export const ResultsWrapper = observer(() => {
  const { detectAndOpenCheckHashPopup } = popupStore;
  const { roundId } = roundInfoStore;

  const { RoundId, Results, Check } = globalTranslationKeys;
  const { CheckHash } = PopupTypes;

  const headerNames = [RoundId, Results, Check];

  const openCheckHash = useCallback(
    ({ currentTarget }) => {
      const selectedId = +currentTarget.getAttribute('name');
      detectAndOpenCheckHashPopup({
        selectedId,
        name: CheckHash,
      });
    },
    [detectAndOpenCheckHashPopup]
  );

  return (
    <GameResults
      headerNames={headerNames}
      renderResultItem={(data) => {
        return (
          <RenderResultItem
            result={data}
            key={data?.roundId}
            status={statusMapper(data, roundId)}
            openCheckHash={openCheckHash}
          />
        );
      }}
    />
  );
});
